// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__bUbpz","loaderOuter":"PageOverlayLoader_loaderOuter__3wdoW"};